import log from 'salvo-lite/log'
import { Loader } from 'google-maps'
import L from 'leaflet'
import 'leaflet.gridlayer.googlemutant'
import rivets from 'rivets'

class StoreLocator {
    constructor (theme, elem) {
        this.elem = elem
        this.mapElem = this.elem.querySelector('[data-map]')
        this.mapScrollToElem = this.elem.querySelector('[data-map-scroll-to]')
        this.map = L.map(this.mapElem).setView([51.505, -0.09], 13)
        this.standardIcon = L.divIcon({ className: 'cicon' })
        this.userMarker = false
        this.geocoder = false
        this.google = null
        this.markers = []
        this.googleLayer = false
        this._data = JSON.parse(this.elem.dataset.storeLocator)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        log.debug(this.constructor.name, 'Initializing', this)
        let loader = new Loader()
        this.google = await loader.load()
        this.googleLayer = new L.GridLayer.GoogleMutant({
            type: 'roadmap'
        })
        this.geocoder = new this.google.maps.Geocoder()
        this.googleLayer.addTo(this.map)
        this.mapReady()
        log.debug(this.constructor.name, 'Initialized', this)
    }

    mapReady () {
        for (let store of this._data.stores) {
            let marker = L.marker([store.lat, store.lon], { icon: this.standardIcon })
            marker.bindPopup(`
                <b>${store.title}</b>
                <div class="store-address">${store.address}</div>
                <div class="store-contact">${store.contact}</div>
            `)
            marker.addTo(this.map)
            this.markers.push({ lat: store.lat, lon: store.lon, marker: marker })
        }
        this.initView()
        rivets.bind(this.elem, this.getModel())
        this.elem.classList.add('store-locator--rendered')
    }

    getModel () {
        return {
            data: this._data,
            controller: {
                searchPostcode: (e, model) => {
                    e.preventDefault()
                    let postcode = this._data.searchValue.trim()
                    if (postcode === '') {
                        this.initView()
                        return
                    }
                    this.geocoder.geocode({
                        address: postcode
                    }, data => {
                        console.log(data)
                        let result = {
                            lat: data[0].geometry.location.lat(),
                            lon: data[0].geometry.location.lng()
                        }
                        if (this.userMarker) {
                            this.map.removeLayer(this.userMarker)
                        }
                        this.userMarker = L.marker([result.lat, result.lon], { icon: this.standardIcon }).addTo(this.map)
                        this.map.setView([result.lat, result.lon], 14)

                        let closest = this.closestXLocations(result, this._data.stores, this._data.showXClosest)
                        this._data.filteredStores = closest
                        this._data.searched = true
                        console.log(closest)
                    })
                    this.mapScrollToElem.scrollIntoView({
                        behavior: 'smooth'
                    })
                },
                goToStore: (e, model) => {
                    e.preventDefault()
                    this.map.setView([model.store.lat, model.store.lon], 14)
                },
                clearSearch: (e, model) => {
                    e.preventDefault()
                    this.initView()
                }
            }
        }
    }

    initView () {
        let firstMarker = this.markers[0]
        this.map.setView([firstMarker.lat, firstMarker.lon], 14)
        this._data.searchValue = ''
        this._data.filteredStores = this._data.stores
        this._data.searched = false
    }

    closestXLocations (targetLocation, locationData, toGet) {
        return locationData.sort((x, y) => {
            if (this.locationDistance(targetLocation, x) < this.locationDistance(targetLocation, y)) {
                return -1
            }
            if (this.locationDistance(targetLocation, x) > this.locationDistance(targetLocation, y)) {
                return 1
            }
            return 0
        }).slice(0, toGet)
    }

    vectorDistance (dx, dy) {
        return Math.sqrt(dx * dx + dy * dy)
    }

    locationDistance (location1, location2) {
        let dx = location1.lat - location2.lat
        let dy = location1.lon - location2.lon
        return this.vectorDistance(dx, dy)
    }
}

export default StoreLocator



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StoreLocator.js